export default __webpack_public_path__ + "static/media/one-star.fe550b4f.png";